import { Component } from '@angular/core';

@Component({
  selector: 'app-create-payout-main',
  templateUrl: './create-payout-main.component.html',
  styleUrls: ['./create-payout-main.component.css']
})
export class CreatePayoutMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
